export default __webpack_public_path__ + "static/media/pc-services-home-banner.bc65503c.png";